export enum FreightBrokerStatusEnum {
	SENT = 'Sent',
	ERROR = 'Error',
	BID = 'Bid'
}
